import { createFileRoute } from '@tanstack/react-router';

import { UsersPage } from '../features/admin/users/UsersPage';
import { usersRouteSearchSchema } from '../features/admin/users/usersRouteSearch';

export const Route = createFileRoute('/admin/users')({
  validateSearch: usersRouteSearchSchema,
  component: UsersPage,
});
